module.exports = __webpack_public_path__ + "media/41.a1e97b4a.mp3";